module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "praise"
    }
  }, [_vm._v("PRAISE FOR THE WRITING OF EDWARD WHITTEMORE")]), _vm._v(" "), _c('h3', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Quin’s Shanghai Circus")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“A profoundly nutty book full of mysteries, truths, untruths, idiot savants, necrophiliacs, magicians, dwarfs, circus masters, secret agents … A marvellous recasting of history in our century.” —"), _c('i', [_vm._v("The New York Times Book Review")])]), _vm._v(" "), _c('h3', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("The Jerusalem Quartet")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Whittemore’s colorful characters … wrestle fitfully with meaninglessness, time, and the grim realities of war… . As in Gabriel Garcia Marquez’s "), _c('i', [_vm._v("One Hundred Years of Solitude,")]), _vm._v(" characters return in name and shape through their progeny, while people, events, and certain phrases are regularly reintroduced, giving you the feeling that you are wandering through a labyrinth of memory.” —"), _c('i', [_vm._v("The Voice Literary Supplement")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“The four books which make up the Jerusalem Quartet are among the richest and most profound in imaginative literature… . A superlative body of work.” —Jeff VanderMeer")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“An epic hashish dream … cosmic … fabulous … droll and moving.” —"), _c('i', [_vm._v("The New York Times Book Review")]), _vm._v(" on "), _c('i', [_vm._v("Sinai Tapestry")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“An author of extraordinary talents, albeit one who eludes comparison with other writers… . The milieu is one which readers of espionage novels may think themselves familiar, and yet it’s totally transformed—by the writer’s wild humour, his mystical bent, and his bicameral perception of history and time.” —"), _c('i', [_vm._v("Harper’s")]), _vm._v(" on "), _c('i', [_vm._v("Jerusalem Poker")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“The final book in what is one of the most wonderful achievements in 20"), _c('sup', [_vm._v("th")]), _vm._v("-century literature… . Without illusion, but with supreme intelligence and a generous heart, Whittemore shows us just how painful, beautiful, and surprising … life’s reversals can be, and how our struggles with ourselves and others can ultimately seem to change time itself.” —"), _c('i', [_vm._v("The Philadelphia Inquirer")]), _vm._v(" on "), _c('i', [_vm._v("Jericho Mosaic")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc5853a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/2praise.vue
// module id = 63
// module chunks = 0